export default "__VITE_ASSET__CZ$RMsNg__"